/**
 * Mexican value-added tax (IVA) rate, expressed as a fraction.
 *
 * Centralizes the `0.16` / `1.16` magic numbers that were duplicated across the
 * cart, checkout, product detail, and product-pricing views. Use:
 *   - tax amount:        amount * IVA_RATE
 *   - amount incl. tax:  amount * (1 + IVA_RATE)  (or withIva(amount))
 *
 * Note: the backend exposes a per-product `taxRate`; the UI currently assumes a
 * flat national rate. If per-product rates ever diverge, switch consumers to the
 * DTO field rather than this constant.
 */
export const IVA_RATE = 0.16

/** Returns `amount` with IVA added. */
export const withIva = (amount: number): number => amount * (1 + IVA_RATE)

/** Returns just the IVA portion of `amount`. */
export const ivaAmount = (amount: number): number => amount * IVA_RATE
